import { HttpInterceptors } from "./http.interceptor";

export class ToReceiveService extends HttpInterceptors {
	async getToReceiveByParams (filters) {
		const response = await this.axios.get("toReceive/getToReceiveByParams", { params: { filters } });
		return response.data;
	}

	async createToReceive (payload) {
		const response = await this.axios.post("toReceive/createToReceive", payload);
		return response.data;
	}

	async updateToReceive (payload) {
		const response = await this.axios.patch("toReceive/updateToReceive", payload);
		return response.data;
	}

	async deleteToReceive (payload) {
		const response = await this.axios.patch("toReceive/deleteToReceive", payload);
		return response.data;
	}

	async recoverToReceive (payload) {
		const response = await this.axios.patch("toReceive/recoverToReceive", payload);
		return response.data;
	}

	async executeReceive (payload) {
		const response = await this.axios.patch("toReceive/executeReceive", payload);
		return response.data;
	}

	async getToReceiveInstallmentsActive (filters) {
		const response = await this.axios.get("toReceive/getToReceiveInstallmentsActive", { params: { filters } });
		return response.data;
	}

	async updateMultiRecords (payload) {
		const response = await this.axios.post("toReceive/updateMultiRecords", payload);
		return response.data;
	}
}
